/**
 * Auth Service – real API only.
 */

import axios from 'axios';
import { apiClient, apiBaseUrl } from './apiClient';
import * as realImpl from './real/authService.real';

export { refreshToken } from './apiClient';

export const loginUser = async (username, password) => {
  const response = await axios.post(
    `${apiBaseUrl}/api/v3/login`,
    JSON.stringify({ email: username, password }),
    {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true,
    },
  );
  return response.data;
};

export const logout = async () => {
  await apiClient.get('/api/web-api/logout/');
};

export const getCurrentUserFromApi = () => realImpl.getCurrentUser();

export const getCurrentUser = async () => realImpl.getCurrentUser();
